import React, { Component } from "react";
import AudioWorkFooterRender from "./children/AudioWorkFooterRender";
import Utils from "@/utils";
import "@/assets/audioCutSpeedVolume.less";

class AudioWorkFooterFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      format: "mp3",
    };
  }

  handleFormatChange = value => {
    this.setState({
      format: value,
    });
  };

  render() {
    return (
      <AudioWorkFooterRender
        handleSubmit={format => {
          let ga = ''
          console.log('this.props.work111',this.props.work);
          if(this.props.work === 'audioVolume'){
            ga = '30ACV'
          }else if(this.props.work === 'audioSpeed'){
            ga = '31ACS'
          }else if(this.props.work === 'audioCut'){
            ga = '32AC'
          }
          let flag = Utils.handleVideoEditorTimes(ga);
          if (flag) {
            return false;
          }
          this.props.handleSubmit(format, true);
        }}
        format={this.state.format}
        handleFormatChange={this.handleFormatChange}
        isSmallerThanLimit={this.props.isSmallerThanLimit}
      />
    );
  }
}

export default AudioWorkFooterFunction;
